import { z } from 'zod';
import { MoneySchema } from './common.js';
export const AssetMasterTypeSchema = z.enum([
    'BUILDING',
    'SIGNAGE',
    'LAND',
    'MACHINE',
    'VEHICLE',
    'OTHER',
]);
export const AssetMasterSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(64),
    type: AssetMasterTypeSchema,
    nameTh: z.string().min(1),
    location: z.string().nullable().optional(),
    // free-text size like '120 sqm' or '4.5x6m' — no structure enforced
    size: z.string().nullable().optional(),
    value: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    ownerDept: z.string().nullable().optional(),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateAssetMasterSchema = AssetMasterSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateAssetMasterSchema = CreateAssetMasterSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=asset-master.js.map